import React, { Component } from 'react'
import { connect } from 'react-redux'
import Countdown from 'react-countdown-now'
import { Divider } from 'antd'
import { timeOutTransaction, processTransactionPush, getBaseWebSocketURL } from '../../actions'
const mapStateToProps = state => {
  return {
    paymentData: state.paymentSimulator.paymentData,
    accessToken: window.localStorage.getItem('app.Authorization'),
    transactionReference: state.paymentSimulator.paymentData.transactionReference,
  }
}

@connect(
  mapStateToProps,
  { timeOutTransaction, processTransactionPush },
)
class PaymentInformationComponent extends Component {
  onExpired = () => {
    this.props.timeOutTransaction()
  }

  renderMinutesCountdown = minutes => {
    if (minutes < 1) {
      return null
    } else {
      return <span>{minutes} minutes</span>
    }
  }
  render() {
    return (
      <div>
        <div className="text-center">
          <h5 className="text-black">
            <strong>
              Please Transfer the amount ₦ {this.props.paymentData.amount} to the account below to
              complete your payment
            </strong>
          </h5>
        </div>
        <Divider />
        <div className="text-center">
          <p>
            <strong>Bank : {this.props.paymentData.bankName}</strong>
          </p>
          <p>
            <strong>Account Number : {this.props.paymentData.accountNumber}</strong>
          </p>
          <p>
            <strong>Account Name : {this.props.paymentData.accountName}</strong>
          </p>
        </div>

        <div className="text-center">
          <br />
          <br />
          <h6>Transaction will expire in</h6>
          <h5 className="text-black">
            <Countdown
              date={Date.now() + this.props.paymentData.accountDurationSeconds * 1000}
              onComplete={this.onExpired}
              renderer={props => {
                return (
                  <div>
                    {this.renderMinutesCountdown(props.minutes)} {props.seconds} seconds
                  </div>
                )
              }}
            />
          </h5>
        </div>
      </div>
    )
  }
}

export default PaymentInformationComponent



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/PaymentSimulationApp/components/PaymentInformationComponent.js